import InfoIcon from "@mui/icons-material/Info";
import { Box, Checkbox, FormControlLabel, IconButton } from "@mui/material";
import useAPI from "../../../../api/hooks/useAPI";
import CustomToolTip from "../../../../components/CustomTooltip";
import { JiraConfigureTicketAction } from "../../../../utils/constants";
import ConfigureDefaultIssueParams from "./ConfigureDefaultIssueParams";
import JiraConfigureTicket from "./JiraConfigureTicket";
import useJiraState from "./useJiraState";

const JiraConfigPage = () => {
  const jiraState = useJiraState({});
  const { trackEvent } = useAPI();

  const handleAutoTicketingChange = (event) => {
    jiraState.setAutoTicketingEnabled(event.target.checked);
    const message = `User ${
      event.target.checked ? "enabled" : "disabled"
    } auto ticketing`;
    trackEvent(message).then();
    if (!event.target.checked) {
      jiraState.handleDisableAutoTicketing();
    }
  };

  return (
    <Box width={600}>
      <FormControlLabel
        control={
          <Checkbox
            checked={jiraState.autoTicketingEnabled}
            onChange={(e) => handleAutoTicketingChange(e)}
          />
        }
        label={
          <Box sx={{ display: "flex", alignItems: "center" }}>
            Enable Auto Ticketing
            <CustomToolTip title="Enabling this means each discovery will open an issue">
              <IconButton size="small" sx={{ ml: 1 }}>
                <InfoIcon fontSize="inherit" />
              </IconButton>
            </CustomToolTip>
          </Box>
        }
      />
      {jiraState.autoTicketingEnabled && (
        <JiraConfigureTicket
          jiraState={jiraState}
          action={JiraConfigureTicketAction.CONFIGURE}
        />
      )}
      <ConfigureDefaultIssueParams jiraState={jiraState} />
    </Box>
  );
};

export default JiraConfigPage;
